import { render, staticRenderFns } from "./AssociazioniLayout.vue?vue&type=template&id=2dd4943d&scoped=true&"
import script from "./AssociazioniLayout.vue?vue&type=script&lang=js&"
export * from "./AssociazioniLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4943d",
  null
  
)

export default component.exports